import _ from "lodash";export default {  validate(values) {    return !_.some(values, function(x) {      return x === null || x === undefined || x === "" || x === [];    });  }};


// WEBPACK FOOTER //
// ./src/helpers/validationHelper.js